import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold" }, "SNS連携の申請を行ないました！")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "py-2 text-left" }, [
    /*#__PURE__*/_createTextVNode(" SHOWで取り上げている特別優待は、インフルエンサーの方に限定公開することを前提としているため、SNS審査をさせて頂きます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 審査には2〜3営業日いただくことがございます。審査に関してご不明な点がございましたら、LINEでお問い合わせください。 ")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}